<div class="custom-snack-bar w-100">
  <div class="d-flex flex-row justify-content-between">
    <div class="snack-bar-icon">
      <mat-icon *ngIf="data.MessageType === 'error'">error</mat-icon>
      <mat-icon *ngIf="data.MessageType === 'success'">check_circle</mat-icon>
      <mat-icon *ngIf="data.MessageType === 'warning'">warning</mat-icon>
    </div>
    <div class="snack-bar-body col text-left">
      <h4 class="snack-bar-title">{{ data.Title }}</h4>
      <div class="snack-bar-content-body">
        {{ data.Message }}


        <div class="btn-container">
          <button class="btn btn-light btn-secondary" (click)="logout()"
            [innerHTML]='resourceService.getViewLabel("Global_Text_BackButton")'></button>
          <button class="btn btn-primary" (click)="externalLogout()"
            [innerHTML]='resourceService.getViewLabel("Global_Text_ExternalLogout")'></button>
        </div>
      </div>

    </div>
  </div>
</div>